import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { Medication } from '@mui/icons-material';
import colors from '../../../shared-colors';

const PrescriptionCard = ({ prescription }) => {
  return (
    <Box
      sx={{
        p: 2,
        backgroundColor: colors.lightTan,
        borderRadius: '8px',
        border: `1px solid ${colors.tan}`,
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <Medication sx={{ color: colors.tanText }} />
        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: colors.black }}>
          {prescription.medication}
        </Typography>
      </Box>

      <Typography variant="body2" sx={{ color: colors.tanText, mb: 1 }}>
        Dosage: {prescription.dosage}
      </Typography>

      {prescription.instructions && (
        <Typography variant="body2" sx={{ color: colors.tanText }}>
          Instructions: {prescription.instructions}
        </Typography>
      )}
    </Box>
  );
};

export default PrescriptionCard;
